import Rails from '@rails/ujs';

function growl_err(message) {
  const alertHTML = `
    <div class="alert alert-danger alert-growl">
      <span aria-hidden="true" class="alert-hide" data-dismiss="alert" style="margin-left:10px;">×</span>
      <i class="fa fa-exclamation-circle margin-right-10"></i>
      ${message}
    </div>`;

  document.body.insertAdjacentHTML('beforeend', alertHTML);

  setTimeout(function () {
    document.querySelectorAll('.alert-growl').forEach((el) => el.remove());
  }, 3000);
}

function handleSignInForm() {
  const form = document.querySelector('form#sign_in_user');
  if (form) {
    form.addEventListener('ajax:before', (event) => {
      if (typeof hcaptcha !== 'undefined' && hcaptcha.getResponse() === '') {
        event.preventDefault();
        const response = hcaptcha.execute(null, { async: true });
        if (response) {
          response
            .then(() => Rails.handleRemote.call(form, event))
            .catch(() => hcaptcha.reset());
        }
      }
    });

    form.addEventListener('ajax:error', (event: CustomEvent) => {
      const data = event.detail[event.detail.length - 1];
      if (typeof hcaptcha !== 'undefined') {
        hcaptcha.reset();
      }
      switch (data.status) {
        case 500:
          growl_err('Error');
          break;
        case 302:
          document.body.insertAdjacentHTML('beforeend', data.responseText);
          break;
        default:
          growl_err(data.responseText);
      }
    });
  }
}

document.addEventListener('turbolinks:load', handleSignInForm);
document.addEventListener('ajax:success', handleSignInForm);
